<template>
  <div class="d-flex align-center">
    <span class="action-icon" @click="$refs.file.click()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <g>
          <path
            fill="none"
            d="M0 0H16V16H0z"
            transform="translate(-1070 -995) translate(1070 995)"
          />
          <path
            d="M13.54 9.861l-1.184-1.184-5.325-5.324A2.51 2.51 0 0 0 3.482 6.9l5.325 5.326a.558.558 0 1 0 .793-.786L4.27 6.114a1.394 1.394 0 0 1 1.972-1.972l5.326 5.325 1.183 1.183A2.511 2.511 0 1 1 9.2 14.2l-.986-.986-5.521-5.523L2.3 7.3a3.626 3.626 0 0 1 5.126-5.131l5.916 5.916a.558.558 0 1 0 .789-.789L8.215 1.38a4.741 4.741 0 0 0-6.706 6.706L7.426 14l.987.986a3.626 3.626 0 0 0 5.127-5.125zm0 0"
            opacity="0.5"
            transform="translate(-1070 -995) translate(1069.872 995)"
          />
        </g>
      </svg>
    </span>
    <input
      type="file"
      class="botter-file-uploader"
      @change="uploadFile"
      ref="file"
    />
  </div>
</template>

<script>
export default {
  name: "inputAttachment",
  data() {
    return {};
  },
  methods: {
    uploadFile(event) {
      this.$store.dispatch("setLoader", true);
      let formObject = new FormData();
      formObject.append("file", event.target.files[0]);
      this.$http_uploads
        .post("/file/upload", formObject)
        .then((response) => {
          this.$emit("sendAttachment", response.data);
        })
        .catch((error) => {
          this.$store.dispatch("setLoader", false);
        });
    },
  },
};
</script>

<style scoped>
.botter-file-uploader {
  height: 0;
  width: 0;
}
</style>
